module.exports = __webpack_public_path__ + "static/media/diagram.b0b704dc.svg";